export const BankLogo = () => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17.5" r="17" fill="#F4F1F2" />
      <path
        d="M10.4556 23.506V14.9876H11.9633V23.506H10.4556ZM16.5366 23.506V14.9876H18.0442V23.506H16.5366ZM7.13867 26.5214V25.0137H22.4165V26.5214H7.13867ZM22.4165 23.506V14.9876H23.9242V23.506H22.4165ZM7.13867 13.4799V12.1481L17.1899 6.41895L27.2411 12.1481V13.4799H7.13867ZM10.5058 11.9722H23.8739L17.1899 8.15278L10.5058 11.9722Z"
        fill="#090B1F"
      />
      <path
        d="M25.5352 28.2148L27.0428 28.2148L27.0428 23.3903L25.5352 23.3903L25.5352 28.2148Z"
        fill="#59968A"
      />
      <path d="M23.875 25.0127V26.5204H28.6996V25.0127H23.875Z" fill="#59968A" />
    </svg>
  );
};
